import { worksOrderGroup } from "@/api/worksOrderGroup/useWorksOrderGroup";
import useFetcher from "@/hooks/useFetcher";
import { useWorksSearchState } from "@/hooks/useWorksState.hook";
import { ProductionPlansGet200ResponseRowsInnerWorksInnerTrackingStatusEnum } from "@sizlcorp/sizl-api-document/dist/models";

const { WAITING, PAUSED, WORKING, DONE } =
  ProductionPlansGet200ResponseRowsInnerWorksInnerTrackingStatusEnum;

interface UseWorksFetchProps {
  equipmentCode: string | undefined;
  enabled?: boolean;
}

export const useWorksOrderGroupFetch = ({
  equipmentCode,
  enabled,
}: UseWorksFetchProps) => {
  const { dates, custName } = useWorksSearchState();

  const query: any = {
    $and: [
      {
        isSlitting: false,
      },
      ...(custName ? [{ CustName: { $eq: custName } }] : []),
    ],
  };

  if (equipmentCode) {
    query.$and.push({ equipmentCode: { $eq: equipmentCode } });
  }

  const { queryKey, queryFn } = worksOrderGroup.find({
    query: query,
    dates,
    // populate: ["equipment", "item", "groupTargetQuantity"],
  });

  const { data, Fetcher } = useFetcher(
    {
      queryKey: queryKey,
      queryFn: queryFn,
    },
    {
      enabled: enabled,
    },
  );

  return { data, Fetcher };
};
